import { useMemo } from 'react';
import type { FieldProps } from './TextField';
import type { QuestionOption } from '../../types';
import { useFormField } from '../../hooks/useFormField';
import { QuestionWrapper } from '../QuestionWrapper';

function normalizeOptions(options: QuestionOption[] = []): QuestionOption[] {
  return options.map((option) => ({
    ...option,
    label: option.label || option.value,
  }));
}

export function DropDownField({ fieldSchema, group }: FieldProps) {
  const field = useFormField(fieldSchema, group);
  const options = useMemo<QuestionOption[]>(
    () => normalizeOptions(fieldSchema.options),
    [fieldSchema.options]
  );

  return (
    <QuestionWrapper {...field} fieldSchema={fieldSchema}>
      <div className="answer-group">
        <div className="answer select">
          <select
            id={`input-${field.question.id}`}
            value={String(field.answer ?? '')}
            onChange={(e) => field.setAnswer(e.target.value)}
          >
            <option value="">Please select</option>
            {options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      </div>
    </QuestionWrapper>
  );
}
